const dots = document.querySelectorAll(".slider-dot");
let currentIndex = 0;
const maxDots = 7; // Define the maximum number of dots

// Function to update the active dot
function updateDots(index) {
    // Remove active class from all dots
    dots.forEach((dot) => dot.classList.remove("active"));

    // Add active class to the new current index, within the bounds of existing dots
    if (index < maxDots && dots[index]) {
        dots[index].classList.add("active");
    } else if (dots.length >= maxDots) {
        // If there are 7 or more dots, the 7th dot should be active
        dots[maxDots - 1].classList.add("active");
    }
}

const sliderComp = document.querySelector("slider-component");
if (sliderComp) {
    sliderComp.addEventListener("slideChanged", function (event) {
        const currentPage = event.detail.currentPage;
        currentIndex = currentPage - 1;
        updateDots(currentIndex);
    });
}

updateDots(currentIndex);